export default __webpack_public_path__ + "static/media/S3275H-min.878b7ab0.jpg";